import { instances } from '@/services/http';
import type { SignUpProspectPostReferredSendCodeRequestType } from '@magma-app/magma-types/sign-up-prospect';
import { useMutation } from '@tanstack/vue-query';

export const useResendCode = () => {
  return useMutation({
    mutationFn: async (
      payload: SignUpProspectPostReferredSendCodeRequestType
    ) => {
      const response = await instances.main.post(
        '/sign-up-prospect/referred/phone/send-code',
        payload
      );
      return response.data;
    },
  });
};
